import React from 'react';
import { IMaskInput } from 'react-imask';
import { validate } from 'react-email-validator';
import {colorStand, colorsTabletops , colorMirror} from '../../utils/colors';
import {sumConfig} from './../../utils/utils';
import TextareaAutosize from 'react-textarea-autosize';
import postOrder from '../../utils/api';
import { pdf } from '@react-pdf/renderer';


export default class ModalForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fields: {
                name: {
                    require: true,
                    validate: false,
                    value: '',
                    message: 'Поле обязательно для заполнения'
                },
                phone: {
                    require: true,
                    validate: false,
                    value: '',
                    message: 'Поле обязательно для заполнения'
                },
                email: {
                    require: true,
                    validate: false,
                    value: '',
                    message: 'Поле обязательно для заполнения'
                },
                comment: {
                    validate: true,
                    value: '',
                    message: ''
                },
                address: {
                    validate: true,
                    value: '',
                    message: ''
                },
            },
        }
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.validate(target.dataset.type, value, name)
    }
    
    
    

    validate(type, value, name) {
        const copyFields = JSON.parse(JSON.stringify(this.state.fields));
        switch(type) {
            case 'phone': {
                const compareValue = value.replace(/[^0-9]/g, '');
                if(compareValue.length === 0) {
                    copyFields[name].validate = false;
                    copyFields[name].message = 'Поле обязательно для заполнения';
                    this.setState(state => {
                        return {
                            fields: copyFields
                        }
                    },() => this.checkAllValid())
                    break;
                }
                if(compareValue.length===11) {
                    copyFields[name].validate = true;
                    copyFields[name].message = '';
                    copyFields[name].value = value;
                    this.setState(state => {
                        return {
                            fields: copyFields
                        }
                    },() => this.checkAllValid())
                }
                else {
                    copyFields[name].validate = false;
                    copyFields[name].message = 'Некорректный номер';
                    this.setState(state => {
                        return {
                            fields: copyFields
                        }
                    },() => this.checkAllValid())

                }
                break;
            }
            case 'email': {

                if(value.length === 0) {
                    copyFields[name].validate = false;
                    copyFields[name].message = 'Поле обязательно для заполнения';
                    this.setState(state => {
                        return {
                            fields: copyFields
                        }
                    },() => this.checkAllValid())
                    break;
                }

                if(validate(value)) {
                    copyFields[name].validate = true;
                    copyFields[name].message = '';
                    copyFields[name].value = value;
                    this.setState(state => {
                        return {
                            fields: copyFields
                        }
                    }, () => this.checkAllValid())
                }
                else {
                    copyFields[name].validate = false;
                    copyFields[name].message = 'Некорректный email';
                    this.setState(state => {
                        return {
                            fields: copyFields
                        }
                    },() => this.checkAllValid())

                }
                break;
            }
            case 'name': {

                if(value.length === 0) {
                    copyFields[name].validate = false;
                    copyFields[name].message = 'Поле обязательно для заполнения';
                    this.setState(state => {
                        return {
                            fields: copyFields
                        }
                    },() => this.checkAllValid())
                    break;
                }

                if(value.length >= 2) {
                    copyFields[name].validate = true;
                    copyFields[name].message = '';
                    copyFields[name].value = value;
                    this.setState(state => {
                        return {
                            fields: copyFields
                        }
                    }, () => this.checkAllValid())
                }
                else {
                    copyFields[name].validate = false;
                    copyFields[name].message = 'Поле не может содержать меньше 2 символов';
                    this.setState(state => {
                        return {
                            fields: copyFields
                        }
                    },() => this.checkAllValid())
                }
                break;
            }
            default: {
                copyFields[name].value = value;
                this.setState(state => {
                    return {
                        fields: copyFields
                    }
                },() => this.checkAllValid())
                break;
            }
        }
    }

    checkAllValid() {
        let fieldsArray = Object.values(this.state.fields);
        const check = fieldsArray.find(item => {
            if(item.validate === null || item.validate === false) {
                return item;
            }
        })
        if(!!!check) {
            this.props.updateNoticeStatus(false);
            this.props.updateValidate('form', true);
        }
        else {
            this.props.updateValidate('form', false);
        }
        this.setState(state => {
            return {
                allValid: !!!check,
            }
        })
    }

    _searchMaterialTabletop(type) {
        let currentMaterial = ''
        let currentType = ''
        for(let key in colorsTabletops) {
            const material = colorsTabletops[key].name;
            const materialObj = colorsTabletops[key].type[0];
            for(let key in materialObj) {
                if(key === type) {
                    currentMaterial = material;
                    currentType = materialObj[key].name;
                }
            }
        }
        return {material: currentMaterial, type: currentType};
    }

    _searchMaterialStand(type) {
        let currentMaterial = ''
        for(let key in colorStand) {
            if(type === key) {
                currentMaterial = colorStand[key][0].name;
            }
        }
        return currentMaterial || type;
    }

    _searchMaterialMirror(type){
        let currentMaterial = ''
        for(let key in colorMirror) {
            if(type === key) {
                currentMaterial = colorStand[key][0].name;
            }
        }
        return currentMaterial;
    }


    async sendToBackend() {
        try {
            this.props.updatePreloader(true);
    
            // Формируем строки описания заказа
            const stringStand = `Тумба: имя: ${this.props.config.stand.name}, артикул: ${this.props.config.stand.fullArticle}, материал: ${this._searchMaterialStand(this.props.config.stand.material)}, ширина: ${this.props.config.stand.stand.width}, высота: ${this.props.config.stand.stand.height}, глубина: ${this.props.config.stand.stand.depth}, цвет: ${this.props.config.stand.color}, ${this.props.config.stand.positionStand !== false ? `Вид тумбы: ${this.props.config.stand.positionStand},` : ''} ${this.props.config.stand.secondMaterial!== false && this.props.config.stand.secondMaterial !== undefined ? `Второй материал ${this._searchMaterialStand(this.props.config.stand.secondMaterial)},`: ''} ${this.props.config.stand.secondColor !== false && this.props.config.stand.secondColor !== undefined ? `Второй цвет ${this.props.config.stand.secondColor}, ` :''}цена: ${this.props.config.stand.price} | `;
            const stringSink = this.props.config.sink !== false ? `Раковина: имя: ${this.props.config.sink.name}, артикул: ${this.props.config.sink.fullArticle}, количество чаш: ${this.props.config.sink.sink.count_cup}, вырез: ${this.props.config.sink.cutout ? 'С вырезом' : 'Без выреза'}, позиция: ${this.props.config.sink.position}, тип: ${this.props.config.sink.type}, Донный клапан: ${this.props.config.sink.flap.name ? this.props.config.sink.flap.name : '-'}, цена: ${this.props.config.sink.price + (this.props.config.sink.position === 'D' ? 2 : 1) * (this.props.config.sink.flap ? Number(this.props.config.sink.flap.price) : 0)} | ` : `Раковина не выбрана | `; 
            const stringTabletop = this.props.config.tabletop !==false ? `Столешница: артикул: ${this.props.config.tabletop.fullArticle}, глубина: ${this.props.config.stand.stand.depth}, цвет: ${this.props.config.tabletop.color}, материал: ${this._searchMaterialTabletop(this.props.config.tabletop.type).material.replace('Матовая эмаль', 'Керамогранит категории A').replace('Глянцевая эмаль', 'Керамогранит категории B')}, позиция выреза: ${this.props.config.tabletop.position}, количество вырезов: ${this.props.config.tabletop.countCup}, тип: ${this._searchMaterialTabletop(this.props.config.tabletop.type).type.replace('Матовая эмаль', 'Керамогранит категории A').replace('Глянцевая эмаль', 'Керамогранит категории B')}, цена: ${this.props.config.tabletop.price + (this.props.config.tabletop.countCup === 2 ? 3500 : 0)}} | ` : `Столешница не выбрана | `;
            const stringMirror = this.props.config.mirror !== false ? `Зеркало: имя ${this.props.config.mirror.name}, артикул: ${this.props.config.mirror.article}, ${this.props.config.mirror.mirror.height === 888 ?  `диаметр: ${this.props.config.mirror.mirror.width}` : `ширина: ${this.props.config.mirror.mirror.width}, высота: ${this.props.config.mirror.mirror.height}`}, глубина: ${this.props.config.mirror.mirror.depth} ${this.props.config.mirror.wMaterial ?`, материал: ${this._searchMaterialMirror(this.props.config.mirror.material)}, цвет: ${this.props.config.mirror.color}, цена: ${this.props.config.mirror.price} | ` : ''}` : 'Зеркало не выбрано';
            const stringCabinet = this.props.config.cabinet !== false ? `Пенал: имя: ${this.props.config.cabinet.name}, артикул: ${this.props.config.cabinet.cabinet.code}, материал: ${this._searchMaterialStand(this.props.config.cabinet.material)}, ширина: ${this.props.config.cabinet.cabinet.width}, высота: ${this.props.config.stand.stand.height}, глубина: ${this.props.config.cabinet.cabinet.depth}, цвет: ${this.props.config.cabinet.color}, позиция петель: ${this.props.config.cabinet.position}, ${this.props.config.cabinet.secondMaterial!== false && this.props.config.cabinet.secondMaterial !== undefined? `Второй материал ${this._searchMaterialStand(this.props.config.cabinet.secondMaterial)}, ` : ''} ${this.props.config.cabinet.secondColor!== false && this.props.config.cabinet.secondColor !== undefined? `Второй Цвет ${this.props.config.cabinet.secondColor},` : ''} цена: ${this.props.config.cabinet.price}` : 'Пенал не выбран';
    
            // Генерируем PDF
            const pdfBase64 = await this.props.generatePdf();
            
            // Формируем данные для отправки
            const orderData = {
                name: this.state.fields.name.value,
                phone: this.state.fields.phone.value,
                email: this.state.fields.email.value,
                address: this.state.fields.address.value,
                comment: this.state.fields.comment.value,
                order: stringStand + stringSink + stringTabletop + stringMirror + stringCabinet,
                pdf: pdfBase64 // Добавляем PDF в формате base64
            };
    
            // Отправляем заказ
            const response = await postOrder.postOrder(orderData);
            
            // Обрабатываем успешный ответ
            this.props.setStatusCheckout(response);
            this.props.changeCurrentStage(3);
            
        } catch (error) {
            // Обрабатываем ошибку
            console.error('Failed to send order:', error);
            this.props.setStatusCheckout(false);
            this.props.changeCurrentStage(3);
            
        } finally {
            // В любом случае выключаем прелоадер
            this.props.updatePreloader(false);
        }
    }


    
    render() {
        const arrayConfig = [];
        for(let key in this.props.config) {
            if(this.props.config[key] !== false) {
                arrayConfig.push(
                    {
                        type: key,
                        config: this.props.config[key]
                    }
                )
            }
        }

        let sum = sumConfig(this.props.config);

        return (
            <form className='form'>
                <div className='input-group'>
                    <div className={`input-item ${this.props.validateParts && !this.state.fields.name.validate ? 'input-item--red' : ''}`}>
                        <input 
                            required
                            data-type = 'name'
                            name = {'name'}
                            onChange = {(e) => {
                                this.handleInputChange(e);
                            }}
                        />
                        <label>ФИО</label>
                        
                        {
                            this.props.validateParts && !this.state.fields.name.validate ? 
                            <label className='input-error'>{this.state.fields.name.message}</label>
                            :
                            ''
                        }
                    </div>

                    <div className={`input-item ${this.props.validateParts && !this.state.fields.phone.validate ? 'input-item--red' : ''}`}>
                        <IMaskInput
                            data-type = 'phone'
                            required = {true}
                            mask = {`+{7} (000) 000-00-00`}
                            name = {'phone'}
                            onChange = {(e) => {
                                this.handleInputChange(e);
                            }}
                        />
                        <label>Телефон</label>
                        {
                            this.props.validateParts && !this.state.fields.phone.validate ? 
                            <label className='input-error'>{this.state.fields.phone.message}</label>
                            :
                            ''
                        }
                        
                    </div>

                    <div className={`input-item ${this.props.validateParts && !this.state.fields.email.validate ? 'input-item--red' : ''}`}>
                        <input 
                            data-type="email"
                            type="email" 
                            required
                            name = {'email'}
                            onChange = {(e) => {
                                this.handleInputChange(e);
                            }}
                        />
                        <label>Email</label>
                        {
                            this.props.validateParts && !this.state.fields.email.validate ? 
                            <label className='input-error'>{this.state.fields.email.message}</label>
                            :
                            ''
                        }
                        
                    </div>
                </div>

                <div className='textarea-item'>
                    <TextareaAutosize 
                        data-type="text"
                        minRows={2}
                        name = 'address'
                        onChange = {(e) => {
                            this.handleInputChange(e);
                        }}
                    />
                    <label>Адрес доставки</label>
                </div>

                <div className='textarea-item'>
                    <TextareaAutosize 
                        data-type="text"
                        minRows={2}
                        name="comment"
                        onChange = {(e) => {
                            this.handleInputChange(e);
                        }}
                    />
                    <label>Комментарий</label>
                </div>

                <div className='order'>
                    {arrayConfig.map(config => {
                        return (
                        <div className='order__item'>
                            <h2 className='order__item-name'>
                                {config.type === 'stand' ? 'Тумба' : 
                                config.type === 'sink' ? 'Раковина' : 
                                config.type === 'tabletop' ? 'Столешница' : 
                                config.type === 'cabinet' ? 'Пенал' :
                                config.type === 'mirror' ? 'Зеркало' : ''} 
                            </h2>
                            <div className='order__item-info'>
                                {
                                config.type === 'stand' ?
                                <>
                                    <div className='order__item-info-row'>
                                        <span className='order__item-info-name'>Модель</span>
                                        <span className='order__item-info-value'>{config.config.name}</span>
                                    </div>
                                    <div className='order__item-info-row'>
                                        <span className='order__item-info-name'>Ширина</span>
                                        <span className='order__item-info-value'>{config.config.stand.width}</span>
                                    </div>
                                    <div className='order__item-info-row'>
                                        <span className='order__item-info-name'>Высота</span>
                                        <span className='order__item-info-value'>{config.config.stand.height}</span>
                                    </div>
                                    <div className='order__item-info-row'>
                                        <span className='order__item-info-name'>Глубина</span>
                                        <span className='order__item-info-value'>{config.config.stand.depth}</span>
                                    </div>
                                    <div className='order__item-info-row'>
                                        <span className='order__item-info-name'>Материал</span>
                                        <span className='order__item-info-value'>{this._searchMaterialStand(config.config.material)}</span>
                                    </div>
                                    <div className='order__item-info-row'>
                                        <span className='order__item-info-name'>Цвет</span>
                                        <span className='order__item-info-value'>{config.config.color}</span>
                                    </div>
                                    {
                                        
                                        config.config.positionStand !== false && config.config.positionStand ?
                                        <div className='order__item-info-row'>
                                            <span className='order__item-info-name'>Тип тумбы</span>
                                            <span className='order__item-info-value'>{config.config.positionStand === 'L' ? 'Слева' : config.config.positionStand === 'R' ? 'Справа' : ''}</span>
                                        </div>
                                        :
                                        <></>
                                    }
                                    {
                                        
                                        config.config.secondMaterial !== false && config.config.secondMaterial ?
                                        <div className='order__item-info-row'>
                                            <span className='order__item-info-name'>Второй материал</span>
                                            <span className='order__item-info-value'>{this._searchMaterialStand(config.config.secondMaterial)}</span>
                                        </div>
                                        :
                                        <></>
                                    }
                                    {
                                        
                                        config.config.secondColor !== false && config.config.secondColor  ?
                                        <div className='order__item-info-row'>
                                            <span className='order__item-info-name'>Второй цвет</span>
                                            <span className='order__item-info-value'>{config.config.secondColor}</span>
                                        </div>
                                        :
                                        <></>
                                    }

                                    
                                    <div className='order__item-info-row'>
                                        <span className='order__item-info-name'>Цена</span>
                                        <span className='order__item-info-value order__item-info-value--price'>{config.config.price + ' Р'}</span>
                                    </div>
                                </>
                                :
                                <>
                                </>  
                                }
                                {
                                    config.type === 'sink' ?
                                    <>
                                        <div className='order__item-info-row'>
                                            <span className='order__item-info-name'>Модель</span>
                                            <span className='order__item-info-value'>{config.config.sink.name}</span>
                                        </div>
                                        <div className='order__item-info-row'>
                                            <span className='order__item-info-name'>Высота столешницы</span>
                                            <span className='order__item-info-value'>{config.config.type.replace(/mm/gi,'')}</span>
                                        </div>
                                        <div className='order__item-info-row'>
                                            <span className='order__item-info-name'>Вырез</span>
                                            <span className='order__item-info-value'>{config.config.sink.cutout ? 'С вырезом' : 'Без выреза'}</span>
                                        </div>
                                        <div className='order__item-info-row'>
                                            <span className='order__item-info-name'>Расположение раковины</span>
                                            <span className='order__item-info-value'>{config.config.position === 'L' ? 'Слева' : config.config.position === 'R' ? 'Справа' : config.config.position === 'C' ? 'Центр' : config.config.position === 'D' ? 'Двойное' : ''}</span>
                                        </div>
                                        <div className='order__item-info-row'>
                                            <span className='order__item-info-name'>Количество чаш</span>
                                            <span className='order__item-info-value'>{config.config.sink.count_cup}</span>
                                        </div>
                                        {
                                            config.config.flap ? 
                                            <>
                                                <div className='order__item-info-row'>
                                                    <span className='order__item-info-name'>Донный клапан</span>
                                                    <span className='order__item-info-value'>{config.config.flap.name}</span>
                                                </div>
                                            </> 
                                            : 
                                            <></>
                                        }
                                        <div className='order__item-info-row'>
                                            <span className='order__item-info-name'>Цена</span>
                                            <span className='order__item-info-value order__item-info-value--price'>{Number(config.config.price)  + (config.config.position === 'D' ? 2 : 1) * Number(config.config.flap ? config.config.flap.price : 0) + ' Р'}</span>
                                        </div>
                                    </>
                                    :
                                    <>
                                    </>
                                }
                                {
                                    config.type === 'tabletop' ?
                                    <>
                                        <div className='order__item-info-row'>
                                            <span className='order__item-info-name'>Количество вырезов</span>
                                            <span className='order__item-info-value'>{config.config.countCup}</span>
                                        </div>
                                        <div className='order__item-info-row'>
                                            <span className='order__item-info-name'>Расположение выреза</span>
                                            <span className='order__item-info-value'>{config.config.position === 'L' ? 'Слева' : config.config.position === 'R' ? 'Справа' : config.config.position === 'C' ? 'Центр' : config.config.position === 'D' ? 'Двойной' : ''}</span>
                                        </div>
                                        <div className='order__item-info-row'>
                                            <span className='order__item-info-name'>Материал</span>
                                            <span className='order__item-info-value'>{this._searchMaterialTabletop(config.config.type).material}</span>
                                        </div>
                                        <div className='order__item-info-row'>
                                            <span className='order__item-info-name'>Тип</span>
                                            <span className='order__item-info-value'>{this._searchMaterialTabletop(config.config.type).type.replace('Матовая эмаль', 'Керамогранит категории A').replace('Глянцевая эмаль', 'Керамогранит категории B')}</span>
                                        </div>
                                        {
                                            config.config.color ? 
                                            <>
                                                <div className='order__item-info-row'>
                                                    <span className='order__item-info-name'>Цвет</span>
                                                    <span className='order__item-info-value'>{config.config.color}</span>
                                                </div>
                                            </>
                                            :
                                            <></>
                                        }
                                        
                                        <div className='order__item-info-row'>
                                            <span className='order__item-info-name'>Глубина столешницы</span>
                                            <span className='order__item-info-value'>{this.props.config.stand.stand.depth}</span>
                                        </div>
                                        <div className='order__item-info-row'>
                                            <span className='order__item-info-name'>Ширина столешницы</span>
                                            <span className='order__item-info-value'>{config.config.tabletop.width}</span>
                                        </div>
                                        <div className='order__item-info-row'>
                                            <span className='order__item-info-name'>Цена</span>
                                            <span className='order__item-info-value order__item-info-value--price'>{config.config.price + (config.config.countCup===2 ? 3530 : 0) + ' Р'}</span>
                                        </div>
                                    </>
                                    :
                                    <>
                                    </>
                                }
                                
                                {
                                    config.type === 'mirror' ?
                                    <>
                                        <div className='order__item-info-row'>
                                            <span className='order__item-info-name'>Модель</span>
                                            <span className='order__item-info-value'>{config.config.name}</span>
                                        </div>
                                        {
                                            config.config.mirror.height===888 ?
                                            <div className='order__item-info-row'>
                                                <span className='order__item-info-name'>Диаметр</span>
                                                <span className='order__item-info-value'>{config.config.mirror.width}</span>
                                            </div>
                                            :
                                            <>
                                                <div className='order__item-info-row'>
                                                    <span className='order__item-info-name'>Ширина</span>
                                                    <span className='order__item-info-value'>{config.config.mirror.width}</span>
                                                </div>
                                                <div className='order__item-info-row'>
                                                    <span className='order__item-info-name'>Высота</span>
                                                    <span className='order__item-info-value'>{config.config.mirror.height}</span>
                                                </div>
                                            </>
                                        }
                                        
                                        <div className='order__item-info-row'>
                                            <span className='order__item-info-name'>Глубина</span>
                                            <span className='order__item-info-value'>{config.config.mirror.depth}</span>
                                        </div>
                                        {config.config.wMaterial ?
                                            <>
                                                <div className='order__item-info-row'>
                                                    <span className='order__item-info-name'>Материал</span>
                                                    <span className='order__item-info-value'>{this._searchMaterialMirror(config.config.material)}</span>
                                                </div>
                                                <div className='order__item-info-row'>
                                                    <span className='order__item-info-name'>Цвет</span>
                                                    <span className='order__item-info-value'>{config.config.color}</span>
                                                </div>
                                            </>
                                            :
                                            <></>
                                        }
                                        
                                        <div className='order__item-info-row'>
                                            <span className='order__item-info-name'>Цена</span>
                                            <span className='order__item-info-value order__item-info-value--price'>{config.config.price + ' Р'}</span>
                                        </div>
                                    </>
                                    :
                                    <></>
                                }
                                {
                                    
                                    config.type === 'cabinet' ?
                                    <>
                                        <div className='order__item-info-row'>
                                            <span className='order__item-info-name'>Модель</span>
                                            <span className='order__item-info-value'>{config.config.name}</span>
                                        </div>
                                        <div className='order__item-info-row'>
                                            <span className='order__item-info-name'>Расположение петель</span>
                                            <span className='order__item-info-value'>{config.config.position === 'L' ? 'Слева' : config.config.position === 'R' ? 'Справа' : config.config.position === 'C' ? 'Центр' : ''}</span>
                                        </div>
                                        <div className='order__item-info-row'>
                                            <span className='order__item-info-name'>Ширина</span>
                                            <span className='order__item-info-value'>{config.config.cabinet.width}</span>
                                        </div>
                                        <div className='order__item-info-row'>
                                            <span className='order__item-info-name'>Высота</span>
                                            <span className='order__item-info-value'>{config.config.cabinet.height}</span>
                                        </div>
                                        <div className='order__item-info-row'>
                                            <span className='order__item-info-name'>Глубина</span>
                                            <span className='order__item-info-value'>{config.config.cabinet.depth}</span>
                                        </div>
                                        <div className='order__item-info-row'>
                                            <span className='order__item-info-name'>Материал</span>
                                            <span className='order__item-info-value'>{this._searchMaterialStand(config.config.material)}</span>
                                        </div>
                                        <div className='order__item-info-row'>
                                            <span className='order__item-info-name'>Цвет</span>
                                            <span className='order__item-info-value'>{config.config.color}</span>
                                        </div>
                                        {
                                            config.config.secondMaterial !== false && config.config.secondMaterial ?
                                            <div className='order__item-info-row'>
                                                <span className='order__item-info-name'>Второй материал</span>
                                                <span className='order__item-info-value'>{this._searchMaterialStand(config.config.secondMaterial)}</span>
                                            </div>
                                            :
                                            <></>
                                        }
                                        {
                                            
                                            config.config.secondColor !== false && config.config.secondColor  ?
                                            <div className='order__item-info-row'>
                                                <span className='order__item-info-name'>Второй цвет</span>
                                                <span className='order__item-info-value'>{config.config.secondColor}</span>
                                            </div>
                                            :
                                            <></>
                                        }
                                        <div className='order__item-info-row'>
                                            <span className='order__item-info-name'>Цена</span>
                                            <span className='order__item-info-value order__item-info-value--price'>{config.config.price + ' Р'}</span>
                                        </div>
                                    </>
                                    :
                                    <>
                                    </>
                                }
                            </div>
                        </div>)
                    })}
                    <div className='order__item'>
                        <div className='order__item-info-row order__item-info-row--total'>
                            <span className='order__item-info-name'>Итог</span>
                            <span className='order__item-info-value'>{sum + ' Р'}</span>
                        </div>
                    </div>
                </div>
                
            </form>
        )
    }
}